import { render, staticRenderFns } from "./ReportSort.vue?vue&type=template&id=559fa351&scoped=true"
import script from "./ReportSort.vue?vue&type=script&lang=ts"
export * from "./ReportSort.vue?vue&type=script&lang=ts"
import style0 from "./ReportSort.vue?vue&type=style&index=0&id=559fa351&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559fa351",
  null
  
)

export default component.exports